module.exports = __webpack_public_path__ + "img/payment.9e59db4a.jpg";